import React from "react";
import { IRetailStoreWithDistance } from "tsi-common-react/src/models/location";
import { ISyncStoreID } from "tsi-common-react/src/models/nominals";
import {
    CSRF_HEADER,
    ajax,
    getCSRFToken,
} from "tsi-common-react/src/utils/ajax";

import iconIconEmail from "../../img/retail-locator/icon-email.svg";
import { EmailSendStorePostData } from "../models";
import { buildStoreData } from "../utils";
import { LocatorSendResultsModal } from "./LocatorSendResults_Modal";
import { LocatorSurveyModal } from "./LocatorSurveyModal";

const sendEmailWithStores = async (
    recipient: string,
    stores: ReadonlyArray<IRetailStoreWithDistance>,
    selectedStores: Set<ISyncStoreID>,
): Promise<void> => {
    const data: EmailSendStorePostData = {
        email: recipient,
        stores: buildStoreData(stores, selectedStores),
    };
    await ajax
        .post("/api/email-retail-locator-results/")
        .set("Accept", "application/json")
        .set(CSRF_HEADER, await getCSRFToken())
        .send(data);
};

export const LocatorSendResultsEmail = (props: {
    stores: ReadonlyArray<IRetailStoreWithDistance>;
    getStoreNumber: (store: IRetailStoreWithDistance) => number;
}): React.ReactNode => {
    const [surveyOpen, setSurveyOpen] = React.useState(false);
    const [surveyEmail, setSurveyEmail] = React.useState("");

    const handleSubmit = async (
        recipient: string,
        selectedStores: Set<ISyncStoreID>,
    ) => {
        await sendEmailWithStores(recipient, props.stores, selectedStores);
        setSurveyOpen(true);
        setSurveyEmail(recipient);
    };

    const handleSurveyClose = () => {
        setSurveyOpen(false);
    };

    return (
        <>
            <LocatorSendResultsModal
                modalClassName="modal-email"
                // TODO(i18n): Use t tagged template: buttonLabel={t`Email Results`}
                buttonLabel="Email Results"
                buttonImgSrc={iconIconEmail}
                // TODO(i18n): Use t tagged template: buttonImgAlt={t`Email Results`}
                buttonImgAlt="Email Results"
                // TODO(i18n): Use t tagged template: modalTitle={t`Email Your Results`}
                modalTitle="Email Your Results"
                // TODO(i18n): Use jt to keep complete sentence together: modalDescription={jt`Check up to ${<strong>10</strong>} ${<span>results</span>} you would like emailed.`}
                modalDescription={
                    <>
                        Check up to <strong>10</strong> <span>results</span> you
                        would like emailed.
                    </>
                }
                inputType="email"
                // TODO(i18n): Use t tagged template: inputPlaceholder={t`Enter an Email Address`}
                inputPlaceholder="Enter an Email Address"
                // TODO(i18n): Use t tagged template: submitButtonLabel={t`Send`}
                submitButtonLabel="Send"
                maxSelected={10}
                stores={props.stores}
                getStoreNumber={props.getStoreNumber}
                onSubmit={handleSubmit}
            />
            <LocatorSurveyModal
                isOpen={surveyOpen}
                email={surveyEmail}
                onClose={handleSurveyClose}
            />
        </>
    );
};
